export const snxServiceStates = {

    // Stack states
    stack_for_check: 'stack-for-check',
    stack_unknown: 'stack-unknown',
    stack_creating: 'stack-creating',
    stack_starting: 'stack-starting',
    stack_created: 'stack-created',
    stack_stopped: 'stack-stopped',
    stack_destroying: 'stack-destroying',

    // Rest Engine states
    re_unkwnon: 're-unkwnon',
    re_starting: 're-starting',
    re_started: 're-started',
    re_metadata_reloading: 're-metadata-reloading',
    re_restarting: 're-restarting'
}

export default snxServiceStates;